module.exports = __webpack_public_path__ + "img/logo.2b2eba47.png";